var _circle, _circle2, _path, _circle3, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermitApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 66.8351,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32979
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 61.8351,
    fill: "#F2F9F1",
    stroke: "#82C275",
    strokeWidth: 1.32979
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.879 58.6363V96.9747H46.001V43.0034H74.8938L86.879 58.6363Z",
    fill: "white",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.3524,
    cy: 46.8029,
    r: 11.4374,
    fill: "#82C275",
    stroke: "white",
    strokeWidth: 2.22074
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2578 63.7146L78.1711 63.7146",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2578 76.2627L78.1711 76.2627",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3516 45.4477L85.4589 50.6216L92.3537 42.9839",
    stroke: "white",
    strokeWidth: 2.22074
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermitApproval);
export default __webpack_public_path__ + "static/media/PermitApproval.aa8ed973146b294f3aa616b0caffbfc2.svg";
export { ForwardRef as ReactComponent };